import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@/features/auth";
import { SubscriptionsLayout, CheckoutFormProvider } from "@/features/subscriptions";

const Component = () => {
  const { accountDetails } = useAuth();

  if (
    accountDetails?.capabilities?.isSubscriptionButtonAvailable ||
    accountDetails?.capabilities?.isSelfUpgradeAvailable
  ) {
    return (
      <CheckoutFormProvider>
        <SubscriptionsLayout />
      </CheckoutFormProvider>
    );
  }

  return <Navigate to="/consent-solutions" replace />;
};

const Route = createFileRoute("/_authorized/subscription")({
  component: () => <Component />,
});

export { Route };
